import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";

import ReviewCategoriescHeader from "./ReviewCategoriescHeader";
import ReviewCategoriesTableHeaders from "./ReviewCategoriesTableHeaders";
import ReviewCategoriesTableRows from "./ReviewCategoriesTableRows";

const ReviewCategoriesMetric = (props: any) => {
  const { title, time, feedbacks, reportsReviewTicketsData } = props;
  return (
    <Box>
      <ReviewCategoriescHeader title={title} time={time} />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <ReviewCategoriesTableHeaders />
          </TableHead>
          <TableBody>
            {reportsReviewTicketsData &&
              reportsReviewTicketsData.map((reportsTicketsData: any) => {
                return (
                  <ReviewCategoriesTableRows
                    reportsReviewTicketsData={reportsTicketsData}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ReviewCategoriesMetric;
